import { Auth } from '@freelancer/auth';
import { Datastore } from '@freelancer/datastore';
import * as Rx from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SiteTheme } from './feature-flags.model';
import * as i0 from "@angular/core";
import * as i1 from "../datastore/core/datastore";
import * as i2 from "../auth/auth.service";
import * as i3 from "../ui/ui.config";
var FeatureFlagsService = /** @class */ (function () {
    function FeatureFlagsService(datastore, auth, uiConfig) {
        this.datastore = datastore;
        this.auth = auth;
        this.uiConfig = uiConfig;
        // FIXME: Should be { [theme: SiteTheme] : FeatureFlagConfig } but there is no SiteTheme type yet.
        // FIXME: Compile static configurations from single-source of truth
        this.configurations = {
            arrow: {
                memberships: false,
                contests: true,
                contestPost: false,
                localJobs: false,
                showcase: false,
                search: false,
                community: false,
                referAClient: true,
                giveGet: false,
                howItWorksPage: false,
                enterprisePage: false,
                aboutFlnltdPages: false,
                projectManagementPage: false,
                services: false,
                polls: false,
                gamification: false,
                preferredFreelancerProgram: false,
                fileUpload: true,
                portfolio: true,
                legacyFreelancerProjectViewPage: true,
            },
            deloitte: {
                memberships: true,
                contests: true,
                contestPost: true,
                localJobs: true,
                showcase: true,
                search: true,
                community: true,
                referAClient: true,
                giveGet: true,
                howItWorksPage: true,
                enterprisePage: true,
                aboutFlnltdPages: true,
                projectManagementPage: true,
                services: true,
                polls: true,
                gamification: true,
                preferredFreelancerProgram: true,
                fileUpload: false,
                portfolio: false,
                legacyFreelancerProjectViewPage: false,
            },
        };
    }
    FeatureFlagsService.prototype.getFlag = function (feature) {
        var _this = this;
        if (this.uiConfig.theme !== undefined &&
            this.uiConfig.theme in this.configurations) {
            return Rx.of(this.configurations[this.uiConfig.theme][feature]);
        }
        return this.auth.isLoggedIn().pipe(switchMap(function (loggedIn) {
            return loggedIn
                ? _this.datastore
                    .document('users', _this.auth.getUserId())
                    .valueChanges()
                    .pipe(map(function (user) {
                    if (user.enterpriseIds !== undefined &&
                        !!user.enterpriseIds.find(function (id) { return id === "deloitte_dc" /* DELOITTE_DC */; })) {
                        return _this.configurations[SiteTheme.DELOITTE][feature];
                    }
                    return true;
                }))
                : Rx.of(true);
        }));
    };
    FeatureFlagsService.ngInjectableDef = i0.defineInjectable({ factory: function FeatureFlagsService_Factory() { return new FeatureFlagsService(i0.inject(i1.Datastore), i0.inject(i2.Auth), i0.inject(i3.UI_CONFIG)); }, token: FeatureFlagsService, providedIn: "root" });
    return FeatureFlagsService;
}());
export { FeatureFlagsService };
